import { render, staticRenderFns } from "./ui-news-slider.component.vue?vue&type=template&id=589884a5&"
import script from "./ui-news-slider.component.vue?vue&type=script&lang=ts&"
export * from "./ui-news-slider.component.vue?vue&type=script&lang=ts&"
import style0 from "./ui-news-slider.component.vue?vue&type=style&index=0&id=589884a5&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports